import { CredentialStatus } from '@seek/ca-myprofile-utils';
import { CertsyVerifiedIndicator } from '@seek/profile-base-ui';
import { useTranslations } from '@vocab/react';
import { Inline, Loader, Stack, Text } from 'braid-design-system';
import React, { Fragment } from 'react';

import { FormDrawer } from 'src/components/FormDrawer/FormDrawer';
import { usePersonalDetails } from 'src/components/Profile/PersonalDetails/data';
import { RIGHT_TO_WORK } from 'src/components/Router';
import { NEXT_ROLE_RIGHT_TO_WORK_FORM } from 'src/reducers/forms';

import { NextRoleDetail } from '../../ReadNextRole/NextRoleDetail/NextRoleDetail';
import { NextRoleSection } from '../../types';
import { EditRightToWork } from '../EditRightToWork/EditRightToWork';
import { thailandNationalityId } from '../EditRightToWork/RightToWorkItem/useResetThRtw';
import { RightToWorkCertsyLink } from '../RightToWorkCertsyLink/RightToWorkCertsyLink';
import { useRightsToWork } from '../data';

import translations from './.vocab';

export const ReadRightToWork = () => {
  const { t } = useTranslations(translations);

  const { rightsToWork, error } = useRightsToWork();

  const showNewVerificationBadge =
    rightsToWork.filter(
      (rtw) => rtw.credential?.status === CredentialStatus.New,
    ).length > 0;

  const { personalDetails } = usePersonalDetails();

  const hasThailandNationality =
    personalDetails?.personalDetails.nationality?.id === thailandNationalityId;

  const overrideAddButton =
    error || hasThailandNationality
      ? false
      : rightsToWork.filter((right) => right.type2).length === 0;

  return (
    <>
      <NextRoleDetail
        title={t('Right to work')}
        section={NextRoleSection.rightToWork}
        showNewBadge={showNewVerificationBadge}
        overrideAddButton={overrideAddButton}
      >
        {error ? (
          <Loader data={{ automation: 'rtw-loading' }} />
        ) : (
          rightsToWork.length > 0 && (
            <Stack space="medium">
              {rightsToWork.map((right) => {
                const tone = right.type2?.formattedDescription
                  ? 'neutral'
                  : 'secondary';
                return (
                  // Use Fragment to honour parent Stack space got verify link below
                  <Fragment key={`rtw-${right.country.countryCode}`}>
                    <Stack space="small">
                      <Text tone="secondary" size="small" weight="strong">
                        {right.country.name}
                      </Text>

                      {right.credential ? (
                        <Stack space="small">
                          <Inline space="xsmall">
                            <Text>{right.type2?.formattedDescription}</Text>
                            <CertsyVerifiedIndicator idSuffix={right.id} />
                          </Inline>
                        </Stack>
                      ) : (
                        <Text tone={tone}>
                          {right.type2?.formattedDescription ||
                            t('Not specified')}
                        </Text>
                      )}
                    </Stack>
                    {!right.credential && right.verificationUrl ? (
                      <RightToWorkCertsyLink
                        linkAction="verify"
                        linkUrl={right.verificationUrl}
                      />
                    ) : null}
                  </Fragment>
                );
              })}
            </Stack>
          )
        )}
      </NextRoleDetail>
      <FormDrawer
        title={t('Right to work')}
        component={EditRightToWork}
        card={RIGHT_TO_WORK}
        formName={NEXT_ROLE_RIGHT_TO_WORK_FORM}
      />
    </>
  );
};
